import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import logo from "assets/imgs/Logo-Principal-Brancopng.png";
import "./styles.scss";

const ContentRegistroSucesso = () => {
  return (
    <div className="content-wrapper">
      <Container>
        <Row className="vh-150 d-flex justify-content-center align-items-center content-cadastro-usuario">
          <Col md={12} lg={10} xs={12}>
            <Card className="shadow">
              <Row className="g-0 h-150">
                <Col md={4} className="column-img-cadastro-usuario ">
                  <img
                    src={logo}
                    alt="Imagem de registro"
                    className="img-fluid card-img"
                  />
                </Col>
                <Col md={8}>
                  <Card.Body className="h-100 d-flex flex-column m-3">
                    <div className="mb-3 mt-4">
                      <h3 className="fw-bold  mb-2">
                        Usuário cadastrado com sucesso!
                      </h3>
                      <p className="mb-5">
                        Acesse o email informado para confirmar seu cadastro.
                      </p>

                      <div className="d-flex justify-content-between gap-3">
                        <Button
                          variant="link"
                          href="/login"
                          className="text-decoration-none"
                        >
                          <FontAwesomeIcon icon={faArrowLeft} size="1x" />{" "}
                          Voltar
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContentRegistroSucesso;
